import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { feedbackMessageHide } from 'src/app/redux/actions/feedbackMessage';
import FeedbackMessage from 'src/app/components/FeedbackMessage';
import OutsideElementEventCatcher from 'src/app/components/OutsideElementEventCatcher';


class FeedbackMessageContainer extends React.PureComponent {
  onClick = () => {
    const { dispatch } = this.props;

    dispatch(feedbackMessageHide());
  };

  render() {
    const { onClick } = this;
    const { template, icon, description } = this.props;

    if (!description) {
      return null;
    }

    return (
      <OutsideElementEventCatcher events={ ['click'] }
                                  callback={ onClick }
                                  render={ ({ reference }) =>
                                    <FeedbackMessage ref={ reference }
                                                     template={ template }
                                                     icon={ icon }
                                                     onClick={ onClick }
                                    >
                                      {description}
                                    </FeedbackMessage>
                                  }
      />
    );
  }
}

FeedbackMessageContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  template: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  ...state.feedbackMessageReducer
});

export default connect(mapStateToProps)(FeedbackMessageContainer);
